
  import {Component, Vue} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import Card from '@/components/material/Card.vue';
  import DlgCompanyNew from '@/modules/admin/companies/_components/DlgCompanyNew.vue';
  import DlgCompanyDelete from '@/modules/admin/companies/_components/DlgCompanyDelete.vue';
  import DlgCompanyUpdate from '@/modules/admin/companies/_components/DlgCompanyUpdate.vue';

  @Component({
    components: {DlgCompanyUpdate, DlgCompanyDelete, DlgCompanyNew, Card},
  })
  export default class VCompanies extends Vue {
    @Action('admin/companies/read') private read!: () => Promise<void>;
    @Getter('admin/companies/all') private companies!: any;

    private headers: any = [
      {
        text: 'Titel',
        align: 'left',
        value: 'company',
      },
      {
        text: 'Email',
        align: 'left',
        value: 'title',
      },
      {
        text: '',
        align: 'left',
        sortable: false,
        value: '',
      },
    ];
    private loading: boolean = false;
    private search: string = '';

    private async mounted() {
      this.loading = true;
      await this.read();
      this.loading = false;
    }
  }
